import jwtDefaultConfig from "./jwtDefaultConfig";
import { VUE_APP_UI_URL } from "../../../environment";
import { getLoginRouteForTimeout } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null;

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig };

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // For Refreshing Token
  subscribers = [];

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig };

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      (config) => {
        // Get token from localStorage
        const accessToken = this.getToken();

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      (response) => {
        if (response.status === 401) {
          // unauthorized
          let path = pURL.parse(response.config.url).path;
          const inApi = new String(path).split("/")[1];
          if (inApi === "api") {
            console.log("Unauthorized API access: " + path);
          }
        }

        return response;
      },
      (error) => {
        /** Do something with response error */
        if (error.response.status == 401 || error.response.status == 403) {
          try {
            if (error.response.status == 401 || error.response.status == 403) {
              this.$router.replace(getLoginRouteForTimeout()).then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "เซสชั่นหมดอายุ",
                    icon: "AlertCircleIcon",
                    variant: "warning",
                    text: "กรุณาเข้าสู่ระบบอีกครั้ง",
                  },
                });
              });
            }
          } catch (error) {
            localStorage.clear();
            //router.push("/login");
            window.location.href = VUE_APP_UI_URL + "/login";
          }

          // swal({
          //     title: "เซสชั่นหมดอายุ",
          //     text: "กรุณาเข้าสู่ระบบอีกครั้ง",
          //     buttonsStyling: false,
          //     confirmButtonClass: "btn btn-success btn-fill",
          //     icon: "warning",
          // }).then((willConfirm) => {
          //     if (willConfirm) {
          //         localStorage.clear();
          //         //window.location.href = VUE_APP_UI_URL + '/#/login';
          //         router.push("/login");
          //     }
          // });
        }
        return Promise.reject(error);
      }
    );
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) =>
      callback(accessToken)
    );
  }

  addSubscriber(callback) {
    this.subscribers.push(callback);
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName);
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName);
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value);
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value);
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args);
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args);
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    });
  }
}
